"use client";

import { HowItWorksSection } from "@/components/sections/how-it-works";
import { howItWorks } from "@/lib/data/services-brand-augmentation";

export function HowItWorks() {
  return (
    <HowItWorksSection
      eyebrow={howItWorks.eyebrow}
      title={howItWorks.title}
      steps={howItWorks.steps}
      accent={howItWorks.accent}
      stepAccents={howItWorks.stepAccents}
    />
  );
}
